export default __webpack_public_path__ + "static/media/clienthighscore.9b791329.png";